import React, { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { Table } from "@commonwealthdevelopment/web-ui-component-library";
import { Header, Body } from "../../components";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import { format } from "date-fns";
import {
  allowedGroups,
  useAuthorization,
} from "../../contexts/AuthorizationContext";

const DATE_FORMAT = "MMMM do yyyy, p";

export const LinkAudit = () => {
  const { groups } = useAuthorization();
  const [data, setData] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const { id } = useParams();

  const { error, execute } = useFetchWithMsal();

  useEffect(() => {
    execute("GET", `audit/${id}`).then((response) => {
      if (response) {
        setData(response);
      }

      setIsLoading(false);
    });
  }, [execute, id]);

  if (
    data &&
    data.email &&
    !groups.some((g) => g.value === allowedGroups.NLS.value)
  )
    return <Navigate to="/" replace />;

  if (
    data &&
    !data.email &&
    !groups.some((g) => g.value === allowedGroups.PROSPECT.value)
  )
    return <Navigate to="/" replace />;

  return (
    <>
      <Header>
        <h1>Authentication Link History</h1>
      </Header>

      <Body>
        {loading || !data ? (
          <h1>Loading...</h1>
        ) : (
          <>
            <h4>
              Link ID: <Link to={`/links/${id}`}>{id}</Link>
            </h4>

            <p style={{ marginTop: "1.5rem" }}>
              <small>
                Authentication Link created for{" "}
                <strong>{data.email ? "end user" : "affiliate"}</strong>
              </small>
            </p>

            <Table width="100%">
              <thead>
                <tr>
                  <th>Create Date</th>
                  <th>Ip Address</th>
                  <th>Type</th>
                  <th>Created By</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {data &&
                  data.auditData.map((d) => (
                    <tr key={d.id}>
                      <td>{format(d.createdAt, DATE_FORMAT)}</td>
                      <td>{d.ipAddress}</td>
                      <td>{d.type}</td>
                      <td>{d.createdBy}</td>
                      <td>{d.description}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </>
        )}

        <Link to="/links">Back to Links</Link>
      </Body>
    </>
  );
};
